/* eslint-disable no-undef */
/* eslint no-param-reassign: "off" */

export default {
  install(Vue, options) {
    Vue.prototype.$points = {
      getPointByLocation(location) {
        if (!location) return { point: null, area: null };
        const { points } = options.store.state.data;
        const allPoints = Object.keys(points).map((id) => points[id]);
        const byLocation = allPoints.filter((point) => {
          point.area = this.getBestArea(point, location);
          return !!point.area;
        });
        const byOrderTime = byLocation.filter((point) => point.order_time_ok);
        const byDeliveryTime = byOrderTime.filter((point) => point.delivery_time_ok);
        let out = [];
        if (byDeliveryTime.length > 0) {
          out = [...byDeliveryTime];
        } else if (byOrderTime.length > 0) {
          out = [...byOrderTime];
        } else if (byLocation.length > 0) {
          out = [...byLocation];
        } else {
          return { point: null, area: null };
        }
        return { point: out[0]._id, area: out[0].area };
      },
      getBestArea(point, location) {
        if (!point.areas || !Array.isArray(point.areas)) return null;
        const areas = point.areas.filter(
          ({ area }) => (area ? this.checkArea(area.area, location) : false)
        );
        if (areas.length === 0) return null;
        areas.sort((a, b) => a.price < b.price);
        return areas[0]._id;
      },
      checkArea(area, location) {
        if (!area) return false;
        area = this.makeArr(area);
        try {
          const latLng = new google.maps.LatLng(location.lat, location.lng);
          const poly = new google.maps.Polygon({ paths: area });
          return google.maps.geometry.poly.containsLocation(latLng, poly);
        } catch (e) {
          console.log('Error:', e);
          return false;
        }
      },
      collectAreas() {
        const out = [];
        const { points } = options.store.state.data;
        Object.keys(points).forEach((id) => {
          const point = points[id];
          if (point && point.areas && Array.isArray(point.areas)) {
            point.areas.forEach((area) => {
              if (!area || !area.area || !area.area.area) return;
              out.push(this.makeArr(area.area.area));
            });
          }
        });
        return out;
      },
      makeArr(val) {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch (e) {
            return [];
          }
        }
        return val;
      }
    };
  }
};
